import React from 'react';
import {Button, ButtonProps, Icon} from '@yandex-data-ui/common';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import addIcon from 'icons/add.svg';

export interface AddButtonProps extends ClassNameProps {
    children: string;
    onClick?: ButtonProps['onClick'];
}

const AddButton: React.FC<AddButtonProps> = ({children, className, onClick}) => (
    <Button className={className} view="outlined" size="l" onClick={onClick}>
        <Icon data={addIcon} size={14} />
        <span>{children}</span>
    </Button>
);

export default AddButton;
